import AlbumDetailTask from '../../requests/tasks/music/AlbumDetailTask';
import RequestManager from '../../requests/RequestManager';
import store from "../../store";

export default new (class AlbumDetailAdapter {
    constructor() {
        this.playlistId = null;
    }

    setPlaylistId(service) {
        //Obtengo el playlist de service, que viene como playlistSTV/50602555
        this.playlistId = service.split('/', 2)[1];
    }

    async getData(data) {
        this.setPlaylistId(data.service);

        let response = {
            data: null,
            error: false,
            dataerror: {}
        };
        const _cm = store.getState().user;
        const cm_access_token = _cm.musicUser && _cm.musicUser.cm_access_token ? _cm.musicUser.cm_access_token : '';
        const params = {
            list_id: this.playlistId,
            tenant_code: 'aaf',
            type: data.user.type,
            pagination: true,
            version: '2.0.0',
            cm_access_token
        };
        
        const headers = {};

        const musicTask = new AlbumDetailTask(params, headers);
        await RequestManager.addRequest(musicTask)
            .then(res => {
                response = res;
            })
            .catch(err => {
                response.dataerror = this.ribbonsFail(`[Error music request API ${err}]`);
            });
        //return response;
        return this.transformApiResponse(response.response);
    }

    transformApiResponse(response) {
        let playlistTracks = [];
        let playlistDetail = {};
        let userInteractions = [];

        if (!(response && response.components && Array.isArray(response.components))) {
            throw new Error('La api no contiene componentes');
        }

        response.components.forEach(section => {
            switch (section.type) {
                case 'HEADER':
                    playlistDetail = this.getPlayListDetail(section);
                    console.log(playlistDetail);
                    break;
                case 'BOTONERA':
                    playlistDetail.cover = this.getSectionInfo(section, 'IMAGE');
                    playlistDetail.numTracks = this.getSectionInfo(section, 'TEXT', 'TEXT_SUB_1');
                    playlistDetail.duration = this.getSectionInfo(
                        section,
                        'TEXT',
                        'TEXT_SUB_1',
                        false
                    );
                    playlistDetail.followers = this.getSectionInfo(section, 'TEXT', 'FOLLOWERS');
                    userInteractions = this.getUserInteractions(section);
                    console.log(userInteractions);
                    break;
                case 'TRACKS_TABLE':
                    playlistDetail.tracks = this.getPlayListDetailTracks(section);
                    playlistTracks = this.getPlaylistTracks(section);
                    console.log(playlistTracks);
                    break;
            }
        });

        const result = {
            playlistDetail: {
                playlistTracks: playlistTracks,
                playlistDetail: playlistDetail,
                userInteractions: userInteractions
            }
        };

        return result;
    }

    getPlaylistTracks(data) {
        return [];
    }

    getPlayListDetailTracks(data) {
        return data.items.map(track => {
            if (track.type === 'TRACKS_TABLE_ITEM') {
                return this.getTrack(track);
            }
        });
    }

    getTrack(track) {
        const properties = track.properties;

        let ret = {
            trackNumber: '',
            id: '',
            internalId: '',
            name: '',
            url: '',
            duration: '',
            albumId: '',
            albumName: '',
            artist: '',
            artistId: [],
            artists: [],
            isFavorite: false
        };

        if(properties) {
            ret = {
                trackNumber: properties.head1 && properties.head1.text ? properties.head1.text : '',
                id: track && track.phonogramId ? track.phonogramId : '',
                internalId: track && track.phonogramId ? track.phonogramId : '',
                name: properties.head2 && properties.head2.text ? properties.head2.text : '',
                url: properties.head5 && properties.head5.image ? properties.head5.image : '',
                duration: properties.head5 && properties.head5.text ? properties.head5.text : '',
                albumId: track && track.phonogramId ? track.phonogramId : '',
                albumName: properties.head4 && properties.head4.text ? properties.head4.text : '',
                artist: properties.head3 && properties.head3.text ? [properties.head3.text] : [],
                artistId: [],
                artists: [],
                //"songSourceType": 2,
                //"playlistId": "50602555",
                isFavorite: false
            }; 
        }

        return ret;
    }

    getPlayListDetail(data) {
        const properties = data.properties;

        return {
            id: this.playlistId,
            title: properties.title && properties.title.text ? properties.title.text : '',
            cover: properties.image && properties.image.text ? properties.image.text : '',
            numTracks: '',
            duration: '',
            isUserPlaylist: false,
            isOwnPlaylist: false,
            //ownerUserId: "53762463",
            isLoading: false,
            isIdentifiedSongsPlaylist: false,
            followers: '',
            isFollowing: true,
            tracks: []
        };
    }

    getUserInteractions(data) {
        return {
            isFavorite: {
                phonograms: [[]],
                radios: [[]]
            },
            isFollowing: {
                playlists: [[]]
            },
            amcoUrl: ''
        };
    }

    getSectionInfo(section, type, style, first = true) {
        if (section.items && Array.isArray(section.items)) {
            if (type === 'IMAGE') {
                let cover = section.items.find(element => element.type == type);
                return cover.properties && cover.properties.source ? cover.properties.source : '';
            }
            if (type === 'TEXT') {
                let itemsFiltered = section.items.filter(element => {
                    return element.type === type && element.properties && element.properties.style && element.properties.style === style;
                });

                let { 0: firstItem, length: l, [l - 1]: lastItem } = itemsFiltered;

                if (first) {
                    return firstItem.properties && firstItem.properties.text ? firstItem.properties.text : '';
                } else {
                    return lastItem.properties && lastItem.properties.text ? lastItem.properties.text : '';
                }
            }
        } else {
            return '';
        }
    }
})();


// WEBPACK FOOTER //
// ./src/components/AlbumDetail/AlbumDetailAdapter.js